"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
var _vuex = require("vuex");
var _UserCard = _interopRequireDefault(require("./components/UserCard"));
var _GeneralInfo = _interopRequireDefault(require("./components/GeneralInfo"));
var _Address = _interopRequireDefault(require("./components/Address"));
var _Education = _interopRequireDefault(require("./components/Education"));
var _Coin = _interopRequireDefault(require("./components/Coin"));
var _Badge = _interopRequireDefault(require("./components/Badge"));
var _SkillSet = _interopRequireDefault(require("./components/SkillSet"));
var _user = require("@/api/user");
var _coin = require("@/api/coin");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _organizations = require("@/api/organizations");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _index = _interopRequireDefault(require("@/directive/permission/index.js"));
var _lifehikesInitData = require("@/lifehikes-init-data");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
// 权限判断指令
var _default = exports.default = {
  name: "UserEdit",
  directives: {
    permission: _index.default
  },
  components: {
    UserCard: _UserCard.default,
    GeneralInfo: _GeneralInfo.default,
    Address: _Address.default,
    Education: _Education.default,
    Coin: _Coin.default,
    Badge: _Badge.default,
    SkillSet: _SkillSet.default
  },
  data() {
    return {
      loading: false,
      user: {},
      coin: {},
      activeTab: "general",
      organizationList: []
    };
  },
  computed: {
    ...(0, _vuex.mapGetters)(["name", "avatar", "roles", "introduction", "email"])
  },
  async created() {
    const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
    const uuid = typeof this.$route.params.id === "undefined" ? this.user.uuid : this.$route.params.id;
    await this.getList().catch(e => {}),
    // 保留原有错误处理
    await this.getUser(token, uuid).catch(e => {}); // 保留原有错误处理

    // 根据权限动态添加请求
    if ((0, _permission.default)(["root", "otr-digital-producer"])) {
      this.getUserCoin(token, uuid, false).catch(e => {});
    }
  },
  methods: {
    checkPermission: _permission.default,
    getUser(token, uuid) {
      this.loading = true;
      return (0, _user.getUser)(token, uuid).then(response => {
        this.loading = false;
        // console.log('page-useredit-response', response.data)
        this.user = response.data;
        let userRole = this.user.role;
        let newUserRoses = _lifehikesInitData.newRoleList.filter(p => userRole.includes(p.key)).map(item => {
          return item.val;
        });
        this.$set(this.user, "role", newUserRoses);
      }).catch(err => {
        this.loading = false;
        (0, _log.showDebugLog)("page-user-err", err);
        (0, _log.displayPopupMessage)(err, "error");
      });
    },
    getUserCoin(token, uuid) {
      return (0, _coin.getUserCoin)(token, uuid, false).then(response => {
        // console.log('page-useredit-coin-response', response.data)
        this.coin = response.data;
        // console.log('coin', this.coin)
      }).catch(err => {
        (0, _log.showDebugLog)("page-user-err", err);
        (0, _log.displayPopupMessage)(err, "error");
      });
    },
    getList() {
      this.loading = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      return (0, _organizations.getAllOrganizations)(token).then(response => {
        this.loading = false;
        this.organizationList = response.data.rows;
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)('getAllOrganizations-api-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    }
  }
};